
import { Component } from 'react';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import './App.css';
import DestinationItem from './DestinationItem';

const destinationList = [
  {
    id: 0,
    imageURL:
      'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693661376/images_k4hcvx.jpg',
    name: 'Harvard University',
    description: 'Cambridge, Massachusetts, UK',
  },
  {
    id: 1,
    imageURL:
      'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693661447/images_1_xawqnw.jpg',
    name: 'Oxford University',
    description: 'Oxford, England',
  },
  {
    id: 2,
    imageURL:
      'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693661502/images_2_tkbapd.jpg',
    name: 'Stanford University',
    description: 'Stanford, California',
  },
  {
    id: 3,
    imageURL:
      'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693631743/download_xkr9aq.jpg',
    name: 'Nanyang Technological University',
    description: 'Nanyang Ave, Singapore',
  },
];

class App extends Component {
  render() {
    return (
      <div className="app-wrapper">
        {/* Navigation */}
        <nav className="navbar">
          <div className="navbar-left">
            <p>Home</p>
            <p>About</p>
            <p>Schedules</p>
            <p>Membership</p>
            <p>Pricing</p>
            <p>Offers</p>
            <button className="btn-primary">Courses</button>
          </div>
          <div className="navbar-right">
          </div>
        </nav>

        {/* Hero Section */}
        <header className="hero-section">
          <img
            src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693723221/Ellipse_46_nxaxi1.svg"
            alt="vector1"
            className="bg-deco-left"
          />
          <div className="hero-content">
            <div className="text-block">
              <p className="subtitle">Discover the beauty of tropics</p>
              <h1 className="title">Tropical Destinations For Students</h1>
              <p className="description">
                Lorem ipsum dolor sit amet consectetur. Sit mattis donec mi
                bibendum integer rutrum nisi. A nec nisl vitae.
              </p>
              <button className="btn-orange">SIGN UP</button>
            </div>
            <img
              src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693723044/Ellipse_49_sbskux.svg"
              alt="vector-right"
              className="bg-deco-right"
            />
            <div className="hero-img-wrapper">
              <img
                src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693584798/image_37_1_xlndlj.png"
                alt="main visual"
                className="main-img"
              />
              <div className="circle-deco"></div>
              
            </div>
          </div>
          <img
            src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693723575/Subtract_yhn6pt.svg"
            alt="circle"
            className="circle-shape"
          />
        </header>

        {/* Testimonial Cards */}
        <section className="testimonial-cards">
          <div className="adventure-text">
            <img
              src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693723221/Ellipse_46_nxaxi1.svg"
              alt="vector"
              className="vector-deco"
            />
            <h2>Topical Adventure For Students</h2>
            <p className="subtext">Student Tropical Vacation: Relax and Recharge</p>
            <ul>
              <li>Lorem ipsum dolor sit amet</li>
              <li>Massa quis natoque sit quam</li>
              <li>Eros non pellentesque elit</li>
              <li>Tortor id euismod habitant</li>
              <li>Sed suspendisse id in ultrices</li>
            </ul>
            <button className="btn-orange">Explore More</button>
          </div>
          <div className="card-container">
            {[1, 2, 3].map((num, i) => (
              <div className="testimonial-card" key={i}>
                <img
                  src={
                    num === 1
                      ? 'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693589595/avatar_1_zj9bot.svg'
                      : num === 2
                        ? 'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693656102/avatar_3_hnfsvz.png'
                        : 'https://res.cloudinary.com/dxgbxchqm/image/upload/v1693656114/avatar_4_cirme0.png'
                  }
                  alt="avatar"
                  className="avatar"
                />
                <div className="card-text">
                  <p className="name">Jenny Wilson</p>
                  <p className="desc">
                    Lorem ipsum dolor sit amet, consectetur adipiscing...
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Destinations Section */}
        <section className="destination-section">
          <h3>Our Destinations</h3>
          <ul className="destination-cards">
            {destinationList.map(destination => (
              <DestinationItem
                key={destination.id}
                destinationDetails={destination}
              />
            ))}
          </ul>
        </section>

        {/* Discount Section */}
        <section className="discount-section">
          <div className="discount-info">
            <p className="discount-offer">Get 20% off for students</p>
            <h2>Student discount available.</h2>
            <p className="description">Get ready for some fun in the sun!</p>
            <ul>
              <li>Lorem ipsum dolor sit amet</li>
              <li>Massa quis natoque sit quam</li>
              <li>Eros non pellentesque elit</li>
              <li>Tortor id euismod habitant</li>
              <li>Sed suspendisse id in ultrices</li>
            </ul>
            <button className="btn-orange">Explore More</button>
          </div>
          <div className="eclipse2">
            <div className="rectangle">.</div>
            <div className="rectangle2">.</div>
            <img
              src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693576611/image_40_kwvaxv.png"
              alt="p"
              className="f-image"
            />
            <div className="ci">.</div>
          </div>
        </section>

        {/* Booking Section */}
        <div className="booking-container">
          <div className="booking-img">
            <div className="rectangular3"></div>
            <img
              src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693639882/image_41_yowogr.png"
              alt="form-img"
            />
            <div className="ca"></div>
          </div>

          <div className="booking-form">
            <h3>Book Now</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>

            <label htmlFor="city">CITY</label>
            <input type="text" id="city" placeholder="City" />

            <div className="d-flex">
              <div>
                <label>ARRIVAL</label>
                <input type="text" placeholder="10 October" />
              </div>
              <div>
                <label>DEPARTURE</label>
                <input type="text" placeholder="11 October" />
              </div>
            </div>

            <div className="d-flex">
              <div>
                <label>STAR</label>
                <div className="input-group">
                  <AiOutlineMinus className="icon" />
                  <input type="text" value="4" readOnly />
                  <AiOutlinePlus className="icon" />
                </div>
              </div>
              <div>
                <label>ROOM</label>
                <div className="input-group">
                  <AiOutlineMinus className="icon" />
                  <input type="text" value="1" readOnly />
                  <AiOutlinePlus className="icon" />
                </div>
              </div>
            </div>

            <button className="btn-black">Book Now</button>
          </div>
        </div>

        {/* Testimonials Section */}
        <section className="testimonial-section">
          <h1 className="testimonial-heading">Testimonials</h1>
          <div className="testimonial-row">
            <div className="testimonial-item">
              <img src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693643818/Avatar_wy0dpj.png" alt="avatar" />
              <p className="name">corey Korsgaard</p>
              <hr />
              <p className="text">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
            <div className="testimonial-item">
              <img src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693644104/Avatar_1_wwsdjt.png" alt="avatar" />
              <p className="name">Jacob Aminoff</p>
              <hr />
              <p className="text">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
            <div className="testimonial-item">
              <img src="https://res.cloudinary.com/dxgbxchqm/image/upload/v1693644113/Avatar_2_qqhgry.png" alt="avatar" />
              <p className="name">Carla Press</p>
              <hr />
              <p className="text">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
            </div>
          </div>
        </section>

        {/* Highlight Section */}
        <section className="highlight-section">
          <h1>Student special: Discounted rates on tropical gateways!</h1>
          <p>
            Let’s embody your beautiful ideas together, simplify the way you
            visualize your next big things.
          </p>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-links">
            <p>Privacy Policy</p>
            <p>Terms of Use</p>
            <p>Sales and Refunds</p>
            <p>Legal</p>
          </div>
          <div className="footer-links">
            <p>About</p>
            <p>Schedules</p>
            <p>Pricing</p>
            <p>Membership</p>
            <p>Joins</p>
          </div>
        </footer>
      </div>
    );
  }
}

export default App;